import styles from "./ResponsivePage.module.css"
import { LeftOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"

export const ResponsivePage = ({ children, pageTitle, onBackClick }) => {
  const navigate = useNavigate()
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick()
      return
    }

    navigate(-1)
  }

  return (
    <>
      <h4 className={`${styles.pageHeading} fw-700 flex gap-m pb-l`}>
        <LeftOutlined width={5} className={styles.backIcon} onClick={handleBackClick} /> {pageTitle}
      </h4>
      {children}
    </>
  )
}

ResponsivePage.propTypes = {
  children: PropTypes.node,
  pageTitle: PropTypes.string,
  onBackClick: PropTypes.func
}
